/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateBusinessImagesBody
 */
export interface UpdateBusinessImagesBody {
    /**
     * 
     * @type {string}
     * @memberof UpdateBusinessImagesBody
     */
    icon?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBusinessImagesBody
     */
    headerImage?: string;
}

/**
 * Check if a given object implements the UpdateBusinessImagesBody interface.
 */
export function instanceOfUpdateBusinessImagesBody(value: object): value is UpdateBusinessImagesBody {
    return true;
}

export function UpdateBusinessImagesBodyFromJSON(json: any): UpdateBusinessImagesBody {
    return UpdateBusinessImagesBodyFromJSONTyped(json, false);
}

export function UpdateBusinessImagesBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateBusinessImagesBody {
    if (json == null) {
        return json;
    }
    return {
        
        'icon': json['icon'] == null ? undefined : json['icon'],
        'headerImage': json['headerImage'] == null ? undefined : json['headerImage'],
    };
}

export function UpdateBusinessImagesBodyToJSON(json: any): UpdateBusinessImagesBody {
    return UpdateBusinessImagesBodyToJSONTyped(json, false);
}

export function UpdateBusinessImagesBodyToJSONTyped(value?: UpdateBusinessImagesBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'icon': value['icon'],
        'headerImage': value['headerImage'],
    };
}

